module.exports = __webpack_public_path__ + "img/82b57c8077869549f5adcc3b057b10f2.png";